import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export const ImproveIcon = memo(
  forwardRef((props, ref) => (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 14 14"
    >
      <path
        d="M8.87196 2.18652L7.86779 4.39171L5.66284 5.39568L7.86779 6.39949L8.87196 8.60465L9.87597 6.39949L12.081 5.39568L9.87597 4.39171L8.87196 2.18652Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.3125"
      />
      <path
        d="M2.98869 2.18652L2.73764 2.73782L2.1864 2.98882L2.73764 3.23976L2.98869 3.79105L3.23969 3.23976L3.79093 2.98882L3.23969 2.73782L2.98869 2.18652Z"
        stroke="currentColor"
        strokeWidth="1.3125"
      />
      <path
        d="M4.05837 7.80249L3.25605 9.1396L1.91895 9.94192L3.25605 10.7441L4.05837 12.0812L4.86059 10.7441L6.1977 9.94192L4.86059 9.1396L4.05837 7.80249Z"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1.3125"
      />
    </SvgIcon>
  ))
);
